import { render } from "./InvestmentsView.vue?vue&type=template&id=7e91e5ca"
import script from "./InvestmentsView.vue?vue&type=script&lang=js"
export * from "./InvestmentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__